import React from "react";

const ConfirmDelete = ({
  visibility,
  id,
  handleDelete,
  handleCancelDelete,
}) => {
  const onConfirm = () => {
    handleDelete(id);
  };

  const isVisible = visibility ? "visible" : "hidden";

  return (
    <div className={`user-art__confirm ${isVisible}`}>
      <h3 className="tool__section-header user-art__delete-header">
        Are you sure?
      </h3>
      <p>If you delete this image you can't use it in your design.</p>

      <div className="user-art__delete-buttons">
        <button className="button button--round" onClick={onConfirm}>
          Delete
        </button>

        <span className="user-art__delete-cancel" onClick={handleCancelDelete}>
          Cancel
        </span>
      </div>
    </div>
  );
};

export default ConfirmDelete;
